import React from 'react'
import * as UI from 'ui'
import { ForEachModel, ValueToCollection, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

export default function ShiftExchangeEvents ({ namePrefix = null }) {
  return (
    <ValueToCollection name={`${namePrefix}_shift.events`}>
      <WhenCollectionIsNotEmpty>
        <div className='flex flex-col mb-4'>
          <UI.Text block capitalize weight='medium'>
            <Translation name='shiftexchange.headers.events' />
          </UI.Text>
          <ForEachModel>
            <UI.Text>
              <Displays.Text name='name' />
            </UI.Text>
          </ForEachModel>
        </div>
      </WhenCollectionIsNotEmpty>
    </ValueToCollection>
  )
}
